import createTicket from './createTicket';

export default createTicket;
